/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Severitycomplaintsent2Inputs */

const en_severitycomplaintsent2 = /** @type {(inputs: Severitycomplaintsent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complaint sent`)
};

const pt_severitycomplaintsent2 = /** @type {(inputs: Severitycomplaintsent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reclamação enviada`)
};

/**
* | output |
* | --- |
* | "Complaint sent" |
*
* @param {Severitycomplaintsent2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const severitycomplaintsent2 = /** @type {((inputs?: Severitycomplaintsent2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Severitycomplaintsent2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_severitycomplaintsent2(inputs)
	return pt_severitycomplaintsent2(inputs)
});
export { severitycomplaintsent2 as "severityComplaintSent" }